import { ERRORS } from 'store/constants';
import { get } from 'lodash';
import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';
import { PAGE_ERROR } from 'constants/errorConstants';

const reducer = (state = initialState[ERRORS], action) => {
  const errors = get(action, 'payload.errors', []);
  const fingerprint = get(action, 'meta.fingerprint');

  if (action.type === types.LOCATION_CHANGE) {
    return initialState[ERRORS];
  }

  if (!fingerprint) {
    return state;
  }

  if (errors.length > 0 && fingerprint) {
    const isPageError = get(action, 'payload.type', null) === PAGE_ERROR;
    const nextFingerprint = isPageError ? PAGE_ERROR : fingerprint;
    return {
      ...state,
      [nextFingerprint]: errors,
      [fingerprint]: errors
    };
  }
  // if fingerprint and no error

  const newState = Object.assign({}, state);
  const existingError = newState[fingerprint];

  if (existingError) {
    delete newState[fingerprint];
    return newState;
  }

  return state;
};

export default reducer;
